import React, { Component } from 'react';
import { Grid, Dropdown, Form, Segment, Header, Button, Modal } from 'semantic-ui-react';
import Loading from '../Loading';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import ReactTable from 'react-table';
import { NotificationManager } from 'react-notifications';
import { loadActionCodes, getClientNAD, getClientHistoryNotes, getSpecialNotes, getSalesActionHistory,
         updateClientNAD, loadClientIdsByCorporate, addSpecialNotes, addClientActionComment, getCreditManagers } from '../../utils/rest';

class ClientAction extends Component {

    constructor(props) {
        super(props);
        this.state = {
            cltClientId: '',
            clientIds: [],
            clientIdParam: null,
            clientNAD: '',
            clientHistoryNotes: [],
            actionComment: "",
            actionCodes: [],
            actionSubCodes: [],
            actionCode: "",
            actionSubCode: "",
            specialNotes: null,
            salesActionHistory: [],
            loading: false,
            hasSpecialNoteChanged: false,
            hasNADChanged: false,
            openCreditManager: false,
            creditManagers: [],
            isClientDisabled: false,
            clientHistoryNoDataText: "Loading...",
            saleActionNoDataText: "Loading..."
        }
    }

    componentDidMount() {
        this.props.addItem("helpFile", "client_action.md");

        let clientId = new URLSearchParams(this.props.location.search).get('clientId');
        if (this.props.params) {
            loadClientIdsByCorporate(this.props.items.currentCorporate).then(response => {
                if (response !== null) {
                    let clientList = [];
                    if (response.length > 0) {
                        this.props.items.corporate.forEach((corp) => {
                            let clientIds = corp.clients.filter((u) => response.includes(u.id))
                            if (clientIds.length > 0) {
                                clientIds = clientIds.map((client, index) => ({
                                    value: client.id,
                                    text: client.name
                                }))
                                clientList.push(...clientIds)
                            }
                        })
                    }
                    this.setState((prevState, props) => {
                        return { clientIds: clientList }
                    })
                }
            })
        }else if (clientId) {
            let clientList = [];
            this.props.items.corporate.some((corp) => {
              let clientIds = corp.clients.filter((u) =>u.id == clientId)
              if(clientIds.length > 0){
                clientList.push({ key: 0, value: clientIds[0].id, text: clientIds[0].name})
                return true;
              }
            })
            this.setState((prevState, props) => {
                return {isClientDisabled: true, clientIds: clientList, cltClientId: parseInt(clientId), clientIdParam: clientId}
            }, () => {this.fetchClientActionData(clientId)})
        }else if(this.props.items.clients.length > 0){
            this.setState((prevState, props) => {
                return { clientIds: this.props.items.clients }
            })
        }
        
        loadActionCodes('AC').then(response => {
            if (response !== null) {
                response.forEach(map => {
                    map['value'] = map.cacValue;
                    map['text'] = map.cacValue;  
                    map['key'] = map.cacId;  
                })
                this.setState((prevState, props) => {
                    return { actionCodes: response }
                })
            }
        })

        loadActionCodes('SC').then(response => {
            if (response !== null) {
                response.forEach(map => {
                    map['value'] = map.cacValue;
                    map['text'] = map.cacValue;  
                    map['key'] = map.cacId;  
                })
                this.setState((prevState, props) => {
                    return { actionSubCodes: response }
                })
            }
        })
    }

    componentDidUpdate(prevProps) {

        if(prevProps.items.clients != this.props.items.clients){
            if(new URLSearchParams(this.props.location.search).get('clientId') == null){
                this.setState((prevState, props) => {
                    return { 
                        clientIds: this.props.items.clients, 
                        cltClientId: '', 
                        clientNAD: '', 
                        clientHistoryNotes: [], 
                        actionComment: "",  
                        actionCode: "", 
                        actionSubCode: "", 
                        specialNotes: null, 
                        salesActionHistory: [],
                        hasSpecialNoteChanged: false,
                        hasNADChanged: false }
                })
            }
        }
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    handleChange = (e, evt) => {
        this.setState({
            [evt.name]: evt.value
        })
    }

    handleNADChange = (e, evt) => {
        this.setState({
            [evt.name]: evt.value,
            hasNADChanged: true
        })
    }

    handleSpecialNotesChange = (e, evt) => {
        this.setState({
            hasSpecialNoteChanged: true,
            specialNotes: {
                ...this.state.specialNotes,
                clientId: this.state.cltClientId,
                specialNote: evt.value
            }
        })
    }

    handleClientIdChange = (e, evt) => {

        let clientId = evt.value;

        this.setState({
            [evt.name]: evt.value,
            clientNAD: '', 
            clientHistoryNotes: [], 
            actionComment: "",  
            actionCode: "", 
            actionSubCode: "", 
            specialNotes: null, 
            salesActionHistory: [],
            hasNADChanged: false,
            hasSpecialNoteChanged: false
        }, () => {this.fetchClientActionData(clientId)})
    }

    fetchClientActionData = (clientId) => {

        let laodingText = "Loading....";
        let noRecordext = "No records found";

        this.setState((prevState, props) => {
            return { saleActionNoDataText: laodingText, clientHistoryNoDataText: laodingText }
        })

        getClientNAD(clientId).then(response => {
            if (response !== null) {
                this.setState((prevState, props) => {
                    return { clientNAD: response }
                })
            }
        })
        
        getClientHistoryNotes(clientId).then(response => {
            if (response !== null && response.length != 0) {
                this.setState((prevState, props) => {
                    return { clientHistoryNotes: response }
                })
            }else{
                this.setState((prevState, props) => {
                    return { clientHistoryNotes: [], clientHistoryNoDataText: noRecordext }
                })
            }
        })

        getSpecialNotes(clientId).then(response => {
            if (response !== null) {
                this.setState((prevState, props) => {
                    return { specialNotes: response }
                })
            }
        })

        this.fetchClientAction(clientId, noRecordext);
    }

    fetchClientAction = (clientId, noRecordext) => {
        getSalesActionHistory(clientId).then(response => {
            if (response !== null & response.length != 0) {
                
                this.setState((prevState, props) => {
                    return { salesActionHistory: response }
                })
            }else{
                this.setState((prevState, props) => {
                    return {salesActionHistory: [], saleActionNoDataText: noRecordext }
                })
            }
        })
    }

    clearNAD = () => {
        this.setState({
            clientNAD: '',
            hasNADChanged: true
        })
    }

    saveNAD = (e) => {
        e.preventDefault();
        if(!this.state.hasNADChanged){
            NotificationManager.info('Kindly change the date');
        }else if(this.state.cltClientId != ''){
            updateClientNAD(this.state.clientNAD, this.state.cltClientId).then(response => {
                if (response !== null) {
                    this.setState({
                        hasNADChanged: false
                    })
                    NotificationManager.success('', 'NAD updated successfully');
                }
            })
        }else{
            NotificationManager.info('Kindly select client Id');
        }
    }

    saveSpecialNotes = (e) => {
        e.preventDefault();
        if(!this.state.hasSpecialNoteChanged){
            NotificationManager.info('Kindly make some change(s) to save');
        }else if (this.state.specialNotes == "" || this.state.specialNotes == null) {
            NotificationManager.info('Kindly add special notes');
        }else{
            this.setState({
                loading: true
            }, () => {
    
                addSpecialNotes(this.state.cltClientId, this.state.specialNotes).then((response) => {
                    if (response !== null) {
                        this.setState({
                            loading: false,
                            specialNotes: response,
                            hasSpecialNoteChanged: false
                        })
                        NotificationManager.success('', 'Updated successfully');
                    }
                }).then((error) => {
                    this.setState({ loading: false })
                })
            })
        }
    }

    loadCreditManagers = (e) => {
        e.preventDefault();
        if(this.state.cltClientId != ''){
            getCreditManagers(this.state.cltClientId).then((response) => {
                if (response !== null) {
                    this.setState({
                        openCreditManager: true,
                        creditManagers: response
                    })
                }
            }).then((error) => {
                this.setState({ loading: false})
            })
        }else{
            NotificationManager.info('Kindly select client Id');
        }
    }

    closeCreditManager = (e) => {
        e.preventDefault();
        this.setState({ openCreditManager: false })
    }

    submitActionComment = (e) => {
        e.preventDefault();
        if(this.state.actionComment == "" ){
            NotificationManager.info('Kindly insert comment');
        }else if(this.state.actionCode == ""){
            NotificationManager.info('Kindly select action code');
        }else if(this.state.actionSubCode == ""){
            NotificationManager.info('Kindly select action sub code');
        }else{
            this.setState({
                loading: true
            }, () => {
                let actionCode = {
                    'clientId': this.state.cltClientId,
                    'comments': this.state.actionComment,
                    'actionCode': this.state.actionCode + this.state.actionSubCode

                }
                addClientActionComment(this.state.cltClientId, actionCode).then((response) => {
                    if (response !== null) {
                        this.setState({
                            loading: false,
                            actionComment: "",  
                            actionCode: "", 
                            actionSubCode: ""
                        }, () => this.fetchClientAction(this.state.cltClientId))
                        NotificationManager.success('', 'Added successfully');
                    }
                }).then((error) => {
                    this.setState({ loading: false })
                })
            })
        }
    }

    handleGridRowExpanded(newExpanded, index, event) {

        const changedCreditManagers = this.state.creditManagers.map((item, sidx) => {
            if(index != sidx){
                return item
            }
            let isExpand = true
            if(item.expand) {isExpand = false}
            return { ...item, expand: isExpand};
        });

        this.setState({ creditManagers: changedCreditManagers})
    }

    render() {
        const defaultExpandedRows = this.state.creditManagers.map((item, sidx) => item.expand);
        if (this.state.loading) {
            return (<Loading />)
        }
        return (
            <div>
                {this.state.loading ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} clientId={this.state.clientIdParam} parent="Client Management" child={[{ name: "Client Action", url: null }]} />
                <Modal open={this.state.openCreditManager} onClose={this.closeCreditManager} closeIcon>
                    <Modal.Header>Credit Manager</Modal.Header>
                    <Modal.Content>
                    <Segment>
                                                    <div className="table-responsive">
                                                    <ReactTable noDataText="No records found" minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.creditManagers && this.state.creditManagers.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -highlight "
                                                            data={this.state.creditManagers}
                                                            expanded={defaultExpandedRows}
                                                            onExpandedChange={(newExpanded, index, event) => this.handleGridRowExpanded(newExpanded, index, event)}
                                                            SubComponent={row => {
                                                                return (
                                                                    <React.Fragment>
                                                                        <br/>
                                                                        <Form style={{marginLeft: '8%'}} className="large right floated">
                                                                            <Form.Group>
                                                                                <Form.Field width={5}>
                                                                                    <Form.Input label='Phone Number' value={row.original.crtPhone} />
                                                                                </Form.Field>
                                                                                <Form.Field width={5}>
                                                                                    <Form.Input label='Fax Number' value={row.original.crtFax} />
                                                                                </Form.Field>
                                                                                <Form.Field width={4}>
                                                                                    <Form.Input label='Portal Access' value={row.original.crtWebaccess} />
                                                                                </Form.Field>
                                                                            </Form.Group>
                                                                            <Form.Group>
                                                                                <Form.Field width={5}>
                                                                                    <Form.Input label='Birthday' value={row.original.birthday} />
                                                                                </Form.Field>
                                                                                <Form.Field width={5}>
                                                                                    <Form.Input label='Mail Code' value={row.original.mailCodeValue} />
                                                                                </Form.Field>
                                                                                <Form.Field width={4}>
                                                                                    <Form.Input label='Notes' value={row.original.crtSeeNotes} />
                                                                                </Form.Field>
                                                                            </Form.Group>
                                                                            <Form.Group>
                                                                                <Form.Field>
                                                                                   <Form.TextArea rows="2" cols="83" label='Blitz' value={row.original.crtGeneralComment} />
                                                                                </Form.Field>
                                                                            </Form.Group>
                                                                        </Form>
                                                                    </React.Fragment>
                                                                )
                                                            }}
                                                            columns={[{
                                                                Header: props => <span data-inverted="" data-position="bottom left"># </span>,
                                                                sortable: true,
                                                                maxWidth: 50,
                                                                filterable: false,
                                                                Cell: row => row.index + 1
                                                            }, {
                                                                Header: props => <span data-inverted="" data-tooltip='Credit Manager Id' data-position="bottom left">CM#</span>,
                                                                accessor: 'crtId',
                                                                sortable: true
                                                            }, {
                                                                Header: props => <span data-inverted="" data-tooltip='Credit Manager Name' data-position="bottom left">Credit Manager</span>,
                                                                accessor: 'crtFirstname',
                                                                sortable: true,
                                                                Cell: row => (
                                                                   <div> { row.original.prefixValue } { row.original.crtFirstname } { row.original.crtLastname }</div>
                                                                )
                                                            },{
                                                                Header: props => <span data-inverted="" data-tooltip='E-mail Address' data-position="bottom left">E-mail Address</span>,
                                                                accessor: 'crtEmail',
                                                                sortable: true
                                                            }, {
                                                                Header: props => <span data-inverted="" data-tooltip='Sales Comments' data-position="bottom left">Sales Comments</span>,
                                                                accessor: 'crtSalesComment',
                                                                Cell: row => (
                                                                    <div style={{wordBreak: "keep-all"}}>{row.original.crtSalesComment}</div>
                                                                ),
                                                                sortable: true
                                                            }]}
                                                        />
                                                    </div>
                                                </Segment>
                                                <Button primary className="small right floated" onClick={this.closeCreditManager}>
                                                    Close
                                                </Button>
                                                <br/>
                                                </Modal.Content>
                </Modal>
                <Grid className="g-bkgd">
                    {this.props.loading ? <Loading /> : ""}
                    <Grid.Row>
                        <Grid.Column>
                            <Segment.Group raised>
                                <Segment inverted className="grey">
                                    <Header as="h4">View Client Information</Header>
                                </Segment>
                                <Segment>
                                    <Form className="small">
                                        <Form.Group>
                                            <Form.Field disabled={this.state.isClientDisabled} width={5} className="required">
                                                <label>Select Client ID:</label>
                                                <Dropdown placeholder='Select Client ID' className="fluid" search selection options={this.state.clientIds} value={this.state.cltClientId} name="cltClientId" onChange={this.handleClientIdChange}></Dropdown>
                                            </Form.Field>
                                            <Form.Field width={4} className="required">
                                                <Form.Input label='Next Contact Date:' placeholder='mm/dd/yyyy' type="date" name="clientNAD" value={this.state.clientNAD} onChange={this.handleNADChange} />
                                            </Form.Field>
                                            <Form.Field>
                                                <br />
                                                <Button primary className="small right floated" onClick={this.saveNAD}>
                                                    Save
                                                </Button>
                                            </Form.Field>
                                            <Form.Field>
                                                <br />
                                                <Button secondary className="small right floated" onClick={this.clearNAD}>
                                                    Clear
                                                </Button>
                                            </Form.Field>
                                            <Form.Field width={1}></Form.Field>
                                            <Form.Field>
                                                <br />
                                                <Button className="small right floated" onClick={this.loadCreditManagers}>
                                                    Credit Managers
                                                </Button>
                                            </Form.Field>
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                {this.state.cltClientId != '' && 
                                <Segment>
                                    <Form className="large">
                                        <Form.Group>
                                            <Form.Field width={9}>
                                                <Segment>
                                                    <Form.Group>
                                                        <Form.Field width={3}>
                                                            <Dropdown placeholder='Action Code' className="fluid" search selection options={this.state.actionCodes} value={this.state.actionCode} name="actionCode" onChange={this.handleChange}></Dropdown>
                                                        </Form.Field>
                                                        <Form.Field width={3} >
                                                            <Dropdown placeholder='Sub Code' className="fluid" search selection options={this.state.actionSubCodes} value={this.state.actionSubCode} name="actionSubCode" onChange={this.handleChange}></Dropdown>
                                                        </Form.Field>
                                                        <Form.Field width={7}>
                                                              <Form.TextArea rows={3} placeholder='Enter Action Comment Here' name="actionComment" value={this.state.actionComment} onChange={this.handleChange} />
                                                        </Form.Field>
                                                        <Form.Field>
                                                                <Form>
                                                                    <Button primary className="small right floated" onClick={this.submitActionComment.bind(this)}>
                                                                        Submit
                                                                    </Button>
                                                                </Form>
                                                        </Form.Field>
                                                    </Form.Group>
                                                </Segment>
                                                <Segment>
                                                    <Form.Group>
                                                        <Form.Field>
                                                            <label>Special Note:</label>
                                                        </Form.Field>
                                                        <Form.Field width={11} >
                                                            <Form.TextArea rows={3} placeholder="Notes.." name="specialNotes" value={this.state.specialNotes == null ? '' : this.state.specialNotes.specialNote} onChange={this.handleSpecialNotesChange} />
                                                        </Form.Field>
                                                        <Form.Field>
                                                                <Form>
                                                                    <Button primary className="small right floated" onClick={this.saveSpecialNotes.bind(this)}>
                                                                        Save Note
                                                                    </Button>
                                                                </Form>
                                                        </Form.Field>
                                                    </Form.Group>
                                                </Segment>
                                                <Segment>
                                                    <Form.Field>
                                                    <Segment inverted className="grey">
                                                    <Header as="h5">Sales Actions:</Header>
                                                </Segment>
                                                <Segment>
                                                    <div className="table-responsive">
                                                        <ReactTable noDataText={this.state.saleActionNoDataText} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.salesActionHistory && this.state.salesActionHistory.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -highlight "
                                                            data={this.state.salesActionHistory}
                                                            columns={[{
                                                                Header: props => <span data-inverted="" data-position="bottom left"># </span>,
                                                                sortable: true,
                                                                maxWidth: 50,
                                                                filterable: false,
                                                                Cell: row => row.index + 1
                                                            }, {
                                                                Header: props => <span data-inverted="" data-tooltip='Date' data-position="bottom left">Timestamp</span>,
                                                                accessor: 'dateFormatted',
                                                                maxWidth: 150,
                                                                sortMethod: (a, b, desc) => {
                                                                    if (new Date(a) < new Date(b)) {
                                                                        return -1
                                                                    }
                                                                    return 1
                                                                }
                                                            }, {
                                                                Header: props => <span data-inverted="" data-tooltip='User name' data-position="bottom left">User</span>,
                                                                accessor: 'createdBy',
                                                                sortable: true
                                                            },{
                                                                Header: props => <span data-inverted="" data-tooltip='Action Code' data-position="bottom left">Action Code</span>,
                                                                accessor: 'actionCode',
                                                                maxWidth: 50,
                                                                sortable: true
                                                            }, {
                                                                Header: props => <span data-inverted="" data-tooltip='Comments' data-position="bottom left">Comments</span>,
                                                                accessor: 'comments',
                                                                Cell: row => (
                                                                    <div style={{wordBreak: "keep-all"}}>{row.original.comments}</div>
                                                                ),
                                                                sortable: true
                                                            }]}
                                                        />
                                                    </div>
                                                </Segment>
                                                    </Form.Field>
                                                </Segment>
                                            </Form.Field>
                                            <Form.Field width={9}>
                                                <Segment inverted className="grey">
                                                    <Header as="h5">Client History Notes</Header>
                                                </Segment>
                                                <Segment>
                                                    <div className="table-responsive">
                                                        <ReactTable noDataText={this.state.clientHistoryNoDataText} minRows={0} defaultPageSize={this.props.reactTable().pageSize} showPagination={this.state.clientHistoryNotes && this.state.clientHistoryNotes.length > this.props.reactTable().pageSize ? true : false} filterable defaultFilterMethod={this.props._customFilter} className="celled -highlight "
                                                            data={this.state.clientHistoryNotes}

                                                            columns={[{
                                                                Header: props => <span data-inverted="" data-position="bottom left"># </span>,
                                                                sortable: true,
                                                                maxWidth: 50,
                                                                filterable: false,
                                                                Cell: row => row.index + 1
                                                            }, {
                                                                Header: props => <span data-inverted="" data-tooltip='Comment Added Time' data-position="bottom left">Timestamp</span>,
                                                                accessor: 'createdDatePortal',
                                                                maxWidth: 150,
                                                                sortMethod: (a, b, desc) => {
                                                                    if (new Date(a) < new Date(b)) {
                                                                        return -1
                                                                    }
                                                                    return 1
                                                                },
                                                            }, {
                                                                Header: props => <span data-inverted="" data-tooltip='User name' data-position="bottom left">User</span>,
                                                                accessor: 'userName',
                                                                maxWidth: 150,
                                                                sortable: true
                                                            }, {
                                                                Header: props => <span data-inverted="" data-tooltip='Comments' data-position="bottom left">Comments</span>,
                                                                accessor: 'clientComment',
                                                                Cell: row => (
                                                                    <div style={{wordBreak: "keep-all"}}>{row.original.clientComment}</div>
                                                                ),
                                                                sortable: true
                                                            }]}
                                                        />
                                                    </div>
                                                </Segment>
                                            </Form.Field>
                                        </Form.Group>
                                    </Form>
                                </Segment>}
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        )
    }

}

export default ClientAction;


// WEBPACK FOOTER //
// ./src/app/ui/client/ClientAction.js